module.exports = __webpack_public_path__ + "static/media/bai_btn1.859e07f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/bai_btn1.png
// module id = 1466
// module chunks = 0